export default {
    controlHub: {
        eyebrow: "Panoramica operativa",
        pageSubtitle:
            "Se è la prima volta: completa la checklist qui sotto, leggi i tre riquadri di sintesi, poi intervieni sulla tabella prioritaria. Usa i filtri per il periodo.",
        onboarding: {
            sectionTitle: "Percorso di avvio",
            sectionSubtitle: "Passaggi fissi per collegare EveMind al tuo modo di lavorare. Spunta le voci man mano che le completi.",
            progressLabel: "{{pct}}% completato",
            markDone: "Segna come fatto: {{title}}",
            todos: {
                email: {
                    title: "Collega l’email aziendale (Profilo → Integrazioni)",
                    action: "Vai alle integrazioni",
                },
                profile: {
                    title: "Completa il profilo aziendale",
                    action: "Apri il profilo",
                },
                container: {
                    title: "Crea o registra il primo container",
                    action: "Crea container",
                },
                document: {
                    title: "Apri un container e visualizza un documento",
                    action: "Sfoglia i container",
                },
                askEve: {
                    title: "Invia la prima domanda ad Ask Eve",
                    action: "Apri Ask Eve",
                },
            },
        },
        clusters: {
            sectionTitle: "Tre sintesi",
            docs: {
                eyebrow: "Documenti e flusso",
                title: "I documenti sono sotto controllo?",
                subtitle: "Quota spedizioni con documentazione completa nel periodo selezionato.",
                primaryHint: "Più è alto, meglio è — meno mancanze o controlli falliti.",
                linePending: "Spedizioni con documenti in sospeso",
                lineDocIssues: "Issue documentali aperti",
                lineCrossMissing: "Documenti mancanti + cross-check",
                cta: "Vedi spedizioni con problemi documentali",
            },
            risk: {
                eyebrow: "Rischio",
                title: "Dove si concentra il rischio?",
                subtitle: "Quota spedizioni in fasce di rischio medio o superiore.",
                primaryHint: "Più è basso, meglio è — dai priorità ad alto e critico.",
                lineHighCritical: "Alto + critico (conteggio)",
                lineMediumPlus: "Medio + alto + critico (conteggio)",
                cta: "Vedi spedizioni a rischio",
            },
            friction: {
                eyebrow: "Attrito logistico",
                title: "Dove c’è attrito operativo?",
                subtitle: "Issue non documentali e spedizioni attive — segnali di ritardi ed eccezioni.",
                primaryHint: "Più issue non documentali, più eccezioni operative da gestire.",
                lineInTransit: "In transito (spedizioni)",
                lineAboutToDepart: "In partenza (ETD entro 2 giorni, booked)",
                lineReviewCenter: "Review Center (elementi in sospeso)",
                lineAllIssues: "Tutti gli issue attivi (totale)",
                topRoute: "Lane principale (per attività): {{route}}",
                ctaIssues: "Apri gli issue",
                ctaReview: "Apri Review Center",
            },
        },
        ledger: {
            title: "Spedizioni prioritarie (per valore a rischio)",
            description:
                "I container con maggior impatto nel periodo selezionato. Apri una riga per documenti, issue e timeline nella pagina spedizione.",
        },
        companySnapshot: {
            title: "Profilo operativo",
            subtitle: "Contesto su lane e commodity — utile dopo aver gestito le priorità sopra.",
        },
        hubCompanySnapshot: {
            title: "Modo di operare",
            subtitle: "Contesto sintetico sul profilo — apri il profilo completo per i dettagli.",
            loadError: "Impossibile caricare il profilo aziendale.",
            metricActivePartners: "Partner attivi",
            metricTotalContainers: "Container (storico)",
            metricTotalContainersFiltered: "Container (periodo selezionato)",
            metricUniqueRoutes: "Rotte uniche",
            metricCommodities: "Commodity",
            topRoutesTitle: "Rotte principali",
            colRoute: "Rotta",
            colShipments: "Spedizioni",
            colValue: "Valore",
            openProfile: "Apri profilo completo",
        },
        toolbar: {
            clear: "Azzera",
            carrierPlaceholder: "Vettore",
            statusPlaceholder: "Stato",
            allCarriers: "Tutti i vettori",
            allStatuses: "Tutti gli stati",
            includeMediumRisk: "Includi rischio medio",
        },
        quickStats: {
            title: "Numeri chiave ({{start}} – {{end}})",
            titleNoRange: "Numeri chiave",
            subtitle: "Scorciatoie verso elenchi filtrati. Il dettaglio è nei riquadri e nella tabella.",
        },
        tabs: {
            containerSummary: "Riepilogo Container",
            companyStats: "Statistiche Azienda",
        },
        timeRange: {
            thisMonth: "Questo Mese",
            last3Months: "Ultimi 3 Mesi",
            last6Months: "Ultimi 6 Mesi",
            last9Months: "Ultimi 9 Mesi",
            thisYear: "Quest'Anno",
        },
        stats: {
            activePartners: "Partner Attivi",
            teamMembers: "Membri del Team",
            pendingReviews: "Review Center - elementi in sospeso",
        },
        tooltips: {
            docIssues: {
                title: "Container con problemi documentali",
                description: "Numero di container con almeno un problema documentale attivo (documenti mancanti, controlli falliti, errori di cross-check)",
            },
            issues: {
                title: "Problemi",
                description: "Totale problemi attivi su tutti i container",
            },
            atRisk: {
                title: "Spedizioni a rischio",
                description: "Container con punteggio di rischio ≥ 25% (medio, alto, critico)",
            },
            highRisk: {
                title: "Spedizioni ad Alto Rischio",
                description: "Container con punteggio di rischio ≥ 50% che richiedono attenzione",
            },
            activePartners: {
                title: "Partner Commerciali Attivi",
                description: "Aziende con cui hai spedizioni attive (destinatari, spedizionieri)",
            },
            teamMembers: {
                title: "Membri del Team Attivi",
                description: "Utenti nella tua organizzazione con accesso a questo workspace",
            },
            pendingReviews: {
                title: "Revisioni in sospeso",
                description:
                    "Voci in attesa di revisione umana — identificazione container, assegnazione documenti, controlli tracking",
            },
        },
        coordinationHub: {
            title: "Cosa guardare per primo",
            subtitle: "Tre aree diverse: aggiornamenti, anomalie e revisioni umane — entra da qui.",
            glossaryLink: "Che differenza c’è?",
            glossaryTitle: "Attività, Issues e Review Center",
            cards: {
                activity: "Attività",
                activityHint: "Feed e aggiornamenti da email",
                issues: "Issues",
                issuesHint: "Problemi aperti su spedizioni e documenti",
                review: "Review Center",
                reviewHint: "Voci che richiedono una decisione umana",
                unread: "non letti nel feed",
                open: "issue aperti",
                pending: "revisioni in sospeso",
            },
            glossary: {
                activityTerm: "Attività",
                activityBody:
                    "Feed cronologico: comunicazioni commerciali, avvisi di sistema e indicatori di non letto su ciò che è cambiato di recente.",
                issuesTerm: "Issues",
                issuesBody:
                    "Problemi strutturati legati a container o documenti (documenti mancanti, check, ritardi). È la coda operativa delle eccezioni.",
                reviewTerm: "Review Center",
                reviewBody:
                    "Coda breve per conferme umane (es. assegnazione documenti, identificazione). Non è il feed generale delle attività.",
            },
        },
        firstSession: {
            title: "Primi passi in EveMind",
            dismiss: "Non mostrare più",
            stepEmail: "Collega la email (Integrazioni nel Profilo)",
            stepContainer: "Apri un container dalla lista per documenti, timeline e issue",
            stepReview: "Controlla il Review Center se hai revisioni in sospeso",
        },
        riskyShipments: {
            title: "Spedizioni a Rischio",
            description: "Container ad alto rischio ordinati per valore a rischio",
            emptyState: "Nessuna spedizione ad alto rischio trovata",
            colStatus: "Stato",
            viewAll: "Vedi tutti",
        },
        companyProfile: {
            title: "Profilo Aziendale",
            profileCompleteness: "Completezza Profilo",
            tradingPattern: "Pattern Commerciale",
            volumeTier: "Livello Volume",
            commodities: "Merci",
            tradeRoutes: "Rotte Commerciali",
            partners: "Partner Commerciali",
            containers: "Attività Container",
            topHsCodes: "Top Codici HS",
            topRoutes: "Top Rotte Commerciali",
        },
    },
    admin: {
        title: "Dashboard",
        subtitle: "Panoramica del sistema e gestione accounts",
        newAccount: "Nuovo Account",
        loading: "Caricamento dashboard...",
        stats: {
            totalAccounts: "Totale Accounts",
            activeAccounts: "Accounts Attivi",
            newThisMonth: "Nuovi Questo Mese",
            suspendedAccounts: "Accounts Sospesi",
        },
        recentAccounts: {
            title: "Accounts Recenti",
            description: "Ultimi 5 accounts creati nel sistema",
            viewAll: "Vedi tutti",
            headers: {
                userType: "User Type",
                legalName: "Nome Legale",
                entityType: "Tipo Entità",
                country: "Paese",
                status: "Stato",
                createdAt: "Data Creazione",
            },
            status: {
                active: "Attivo",
                suspended: "Sospeso",
                inactive: "Inattivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Panoramica container e collaborazioni",
        loading: "Caricamento dashboard...",
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
            containersWithDocIssues: "Con problemi doc",
            issues: "Con problemi",
            atRisk: "A rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container creati",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                route: "Route",
                progress: "Progresso",
                eta: "ETA",
                docStatus: "Stato Doc",
                riskLevel: "Livello Rischio",
                value: "Valore",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Panoramica dei container ricevuti e collaborazioni",
        loading: "Caricamento dashboard...",
        newOrderRequest: "Richiesta Nuovo Ordine",
        manageShippers: "Gestisci Spedizionieri",
        viewContainers: "Vedi Container",
        newOrderModal: {
            title: "Nuova Richiesta Ordine",
            shipper: "Spedizioniere",
            shipperPlaceholder: "Seleziona un spedizioniere",
            targetWeek: "Settimana Target",
            packingList: "Packing List Richiesta",
            packingListPlaceholder: "Descrivi in dettaglio la packing list richiesta...",
            notes: "Note",
            notesPlaceholder: "Note aggiuntive sull'ordine...",
            submit: "Crea Ordine"
        },
        stats: {
            totalContainers: "Totale Container",
            inTransit: "In Transito",
            delivered: "Consegnati",
            delayed: "In Ritardo",
            pendingDocuments: "Documenti Pending",
            highRisk: "Alto Rischio",
        },
        collaborations: {
            title: "Collaborazioni",
            total: "Totale",
            active: "Attive",
            pending: "Pending",
        },
        team: {
            title: "Team",
            total: "Totale",
            active: "Attivi",
        },
        recentContainers: {
            title: "Container Recenti",
            description: "Ultimi 5 container ricevuti",
            viewAll: "Vedi tutti",
            headers: {
                containerId: "Rif. Container",
                shipper: "Spedizioniere",
                route: "Route",
                progress: "Progress",
                docStatus: "Doc Status",
                riskLevel: "Risk Level",
            },
        },
        monthlyTrend: {
            title: "Andamento Mensile",
        },
        trendVsLastMonth: "vs mese scorso",
        receivedContainers: "Container Ricevuti",
        activeShippers: "Spedizionieri Attivi",
        charts: {
            commodityDistribution: "Distribuzione Commodity",
            originCountries: "Paesi di Origine",
            arrivalPorts: "Porti di Arrivo",
        },
    },
};
